module.exports = __webpack_public_path__ + "img/icon_zanweikaitong.daa09d02.png";